import React, { useContext, useEffect } from "react";
import { Routes, Route, Outlet, useNavigate } from "react-router-dom";
import "./index.css";
import "./chart.css";
import "./step.css";
import Nav from "./layouts/nav";
import Home from "./components/Dashboard/Home";
import { Alluser } from "./components/Users/allUser";
import { ThemeContext } from "../context/ThemeContext";
import { Toaster } from "react-hot-toast";
import { publicProvider } from "wagmi/providers/public";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";
import {
  darkTheme,
  getDefaultWallets,
  RainbowKitProvider,
} from "@rainbow-me/rainbowkit";
import { bsc, bscTestnet, opBNBTestnet, polygon } from "wagmi/chains";
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import "@rainbow-me/rainbowkit/styles.css";
import Login from "./pages/Login";
import { useDispatch } from "react-redux";
import { setLogin } from "./redux/reducer";
import { LevelUpgrade } from "./components/Users/levelUpgrade";

import NodeApprove from "./components/Users/NodeGroup/NodeApprove";
import NodePending from "./components/Users/NodeGroup/NodePending";

import Support from "./components/Users/Support/Support";
import SupportCharts from "./components/Users/Support/SupportCharts";
import LapseWalletset from "./components/Users/LapseWalletset";
import PendingWithdraw from "./components/Users/pendingWithdraw";
import ApproveWith from "./components/Users/ApproveWith";
import ActiveUser from "./components/Users/activeUser";
import InActiveUser from "./components/Users/inactiveUser";
import TeamList from "./components/Users/teamList";
import UserProfile from "./components/Users/userProfile";
import AdminChnage from "./components/Users/adminChnage";
import IncomeReport from "./components/Users/incomeReport";
import WithdarwReport from "./components/Users/withdrawReport";
import AdminImageUpload from "./components/Dashboard/Uploadpanel";
import Queue from "./components/Dashboard/Queue";
import RewardWalletChange from "./components/Dashboard/RewardWalletChange";
import Bannerpanel from "./components/Dashboard/Bannerpanel";
import TicketChat from "./components/Dashboard/Ticketchat";
import Chat from "./components/Dashboard/Chat";
import NotificationComponent from "./components/Dashboard/Notification";
const Markup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const adminToken = localStorage.getItem("adminToken");

  useEffect(() => {
    if (adminToken) {
      dispatch(setLogin(true));
      // navigate("/dashboard");
      console.log("Admin Token found:", adminToken);
    } else {
      dispatch(setLogin(false));
      navigate("/login");
      console.log("No admin token found.");
    }
  }, [adminToken]);
  const allroutes = [
    { url: "", component: <Home /> },
    { url: "/dashboard", component: <Home /> },
    { url: "/userList", component: <Alluser /> },
    { url: "/active-user", component: <ActiveUser /> },
    { url: "/inactive-user", component: <InActiveUser /> },
    { url: "/level-upgrade", component: <LevelUpgrade /> },
    { url: "/UploadImage", component:<AdminImageUpload/>},
    { url: "/ReawardWalletchange", component:<RewardWalletChange/>},
    { url: "/UploadBanner", component:<Bannerpanel/> },
    { url: "/team-list", component: <TeamList /> },
    { url: "/user-profile", component: <UserProfile /> },

    { url: "/support-chats", component: <Chat/> },
    { url: "/notification", component: <NotificationComponent/> },
    { url: "/support", component: <TicketChat/> },
    { url: "/setLapseWallet", component: <LapseWalletset /> },
    { url: "/pending-withdraw", component: <PendingWithdraw /> },
    { url: "/approve-withdraw", component: <ApproveWith /> },
    // { url: "/admin-chnage", component: <AdminChnage /> },
    { url: "/income-report", component: <IncomeReport /> },
    { url: "/withdraw-report", component: <WithdarwReport /> },
  ];

  //Bsc testnet
  // var mbscTestnet = {
  //   id: 97,
  //   name: "Binance Smart Chain Testnet",
  //   network: "bsc-testnet",
  //   nativeCurrency: {
  //     decimals: 18,
  //     name: "BNB",
  //     symbol: "tBNB",
  //   },
  //   rpcUrls: {
  //     // default: { http: ["https://data-seed-prebsc-1-s2.binance.org:8545"] },
  //     default: { http: ["https://data-seed-prebsc-1-s2.binance.org:8545"] },
  //   },
  //   blockExplorers: {
  //     etherscan: { name: "BscScan", url: "https://testnet.bscscan.com" },
  //     default: { name: "BscScan", url: "https://testnet.bscscan.com" },
  //   },
  //   contracts: {
  //     multicall3: {
  //       address: "0xca11bde05977b3631167028862be2a173976ca11",
  //       blockCreated: 17422483,
  //     },
  //   },
  //   testnet: true,
  // };
  const BSC = {
    id: 56,
    name: "Binance Smart Chain",
    nativeCurrency: {
      decimals: 18,
      name: "BNB",
      symbol: "BNB",
    },
    rpcUrls: {
      default: { http: ["https://bsc-pokt.nodies.app"] },
      public: { http: ["https://bsc-pokt.nodies.app"] },
    },
    blockExplorers: {
      default: {
        name: "Binance Smart Chain",
        url: "https://bscscan.com/",
        apiUrl: "https://bscscan.com/api",
      },
    },
    testnet: true,
  }

  const { chains, publicClient, webSocketPublicClient } = configureChains(
    [BSC],
    [
      jsonRpcProvider({
        rpc: (chain) => ({
          http: `${chain.rpcUrls.default.http[0]}`,
        }),
      }),
      publicProvider(),
    ]
  );
  
  const projectId = "24fb23164e7f77e68afeff05da5f7026";
  const { connectors } = getDefaultWallets({
    appName: "My RainbowKit App",
    projectId,
    chains,
  });

  const wagmiClient = createConfig({
    autoConnect: true,
    connectors,
    publicClient,
    webSocketPublicClient,
  });
  

  return (
    <>
      <Toaster position="top-center" />
      <WagmiConfig config={wagmiClient}>
        <RainbowKitProvider
          chains={chains}
          modalSize="compact"
          theme={darkTheme()}
        >
          <Routes>
            <Route element={<MainLayout />}>
              {allroutes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`${data.url}`}
                  element={data.component}
                />
              ))}
            </Route>
            <Route path="/login" element={<Login />} />
          </Routes>
        </RainbowKitProvider>
      </WagmiConfig>
    </>
  );
};

function MainLayout() {
  const { menuToggle } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${menuToggle ? "menu-toggle" : ""}`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default Markup;
